import React from "react";
import { format } from "date-fns";
import { AccountingReportFilters } from "../types";
import { CardSection } from "../../general/Card/CardSection";
import { AccountingReportHeader } from "../AccountingReportHeader";
import { Card } from "../../general/Card/Card";
import { Entity } from "../../../common/types/entity";
import { TrialBalanceResponse } from "../../../common/contracts/accounting-reports";
import { AccountingReportFooter } from "../AccountingReportFooter";
import { ExcelTableWrapper } from "../../excelExport/ExcelTableWrapper";
import { TrialBalanceTableContainer } from "./TrialBalanceTableContainer";
import { TrialBalanceDownloadTable } from "./trialBalanceDownload/TrialBalanceDownloadTable";

interface Props {
    data: TrialBalanceResponse;
    filters: AccountingReportFilters;
    entity: Entity;
    generationDate: Date;
}

export const TrialBalancePageContent: React.FC<Props> = ({
    data,
    filters,
    entity,
    generationDate,
}) => {
    const dateLabel =
        filters.endDate && "As of " + format(filters.endDate, "MMMM d, yyyy");

    return (
        <>
            <Card stacked>
                <CardSection>
                    <AccountingReportHeader
                        entityName={entity.name ?? ""}
                        reportType="Trial Balance"
                        dateLabel={dateLabel}
                    />
                </CardSection>
                <TrialBalanceTableContainer data={data} />
                <AccountingReportFooter generationDate={generationDate} />
            </Card>
            <ExcelTableWrapper>
                <TrialBalanceDownloadTable
                    report={data}
                    entity={entity}
                    filters={filters}
                    generationDate={generationDate}
                />
            </ExcelTableWrapper>{" "}
        </>
    );
};
